import { Typography } from "@/components/atoms";

const Graphic = () => (
  <div className="relative h-[73px] w-[164px]">
    <div className="absolute left-[40px] top-0 size-[52px] -rotate-[15deg] rounded-lg bg-[#9E77ED] opacity-50" />
    <div className="absolute left-[80px] top-[3px] size-[44px] rotate-[30deg] rounded-lg bg-[#6941C6] opacity-20" />
    <div className="absolute bottom-[6px] left-1/2 h-12 w-[164px] -translate-x-1/2 overflow-hidden rounded-md border border-neutral-mid-gray bg-white shadow-[0px_4px_12px_-4px_rgba(71,84,103,0.1)]">
      <div className="absolute left-[11px] top-[9px] h-[9px] w-[76px] rounded-full bg-neutral-gray" />
      <div className="absolute left-[11px] top-[28px] h-[9px] w-[95px] rounded-full bg-neutral-gray" />
      <div className="absolute left-[116px] top-[28px] h-[9px] w-[17px] rounded-full bg-neutral-gray" />
    </div>
  </div>
);

export const GuestPassengersEmptyState = () => (
  // sticky + max-w keep the content centred in the visible area when the table scrolls horizontally on mobile.
  <section className="sticky left-0 flex max-w-[calc(100vw-44px)] flex-col place-items-center p-8 lg:p-16">
    <Graphic />
    <div className="mt-6 text-center">
      <Typography variant="action" className="mb-1 block text-neutral-dark-gray">
        No Guest Passengers
      </Typography>
      <Typography className="max-w-[400px] text-neutral-dark-gray">
        There are currently no guest passengers saved. Add guests for a smoother booking experience
      </Typography>
    </div>
  </section>
);
